/* eslint-disable */
// @ts-nocheck
import Script from 'next/script';
import { useContext } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import isWebView from '~/utils/isWebView';

import { INTERCOM_API_BASE, INTERCOM_APP_ID } from './constants';
import { useIntercomAuthTokenSync } from './useIntercomAuthTokenSync';
import { useIntercomJwt } from './useIntercomJwt';

function IntercomLoggedIn() {
  const { user } = useContext(UserContext);
  const webView = isWebView();
  const { jwt, isLoading } = useIntercomJwt();

  // Wait for the JWT so the first boot is already verified. If fetching it failed we still boot
  // (unverified) — Intercom rejects that once web enforcement is on, which is visible in its dashboard.
  const isMessengerBooted = !webView && !!user?.email && !isLoading;

  // This component stays mounted across logout, so the sync follows the boot gate rather than the mount.
  useIntercomAuthTokenSync(isMessengerBooted);

  if (!isMessengerBooted) {
    return null;
  }

  return (
    <>
      <Script id="intercomSettings">
        {
          (window.intercomSettings = {
            api_base: INTERCOM_API_BASE,
            app_id: INTERCOM_APP_ID,
            email: user.email,
            handle: user.handle,
            name: user.firstName + ' ' + user.lastName,
            user_id: user.id,
            ...(jwt && { intercom_user_jwt: jwt }),
          })
        }
      </Script>

      <Script id="initIntercom">
        {(function () {
          const w = window;
          const ic = w.Intercom;
          if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
          } else {
            const d = document;
            var i = function () {
              i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
              i.q.push(args);
            };
            w.Intercom = i;
            const l = function () {
              const s = d.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
              const x = d.getElementsByTagName('script')[0];
              x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === 'complete') {
              l();
            } else if (w.attachEvent) {
              w.attachEvent('onload', l);
            } else {
              w.addEventListener('load', l, false);
            }
          }
        })()}
      </Script>
    </>
  );
}

export default IntercomLoggedIn;
